import React, {useState} from 'react';
import {
  IconButton,
  InputAdornment,
  Container,
  CssBaseline,
  TextField,
  Button,
  Typography,
  makeStyles,
  Snackbar,
} from '@material-ui/core';
import {Visibility, VisibilityOff} from '@material-ui/icons';
import {useHistory} from 'react-router-dom';
import authFetch from '../../helpers/requests';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  form: {width: '100%', marginTop: theme.spacing(1)},
  submit: {margin: theme.spacing(3, 0, 2)},
}));

export default function ChangePassword() {
  const classes = useStyles();
  const history = useHistory();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState({open: false, text: ''});
  const [loading, setLoading] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirm) {
      setMessage({open: true, text: 'Las contraseñas no coinciden'});
      return;
    }
    setLoading(true);
    try {
      const user = JSON.parse(sessionStorage.getItem('user') || 'null');
      if (!user?.token) {
        setMessage({
          open: true,
          text: 'Sesión inválida, vuelva a iniciar sesión',
        });
        setLoading(false);
        return;
      }

      const r = await authFetch(
        '/api/collaborator/change-password',
        {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({currentPassword, newPassword}),
        },
        user.token,
      );
      if (r.ok) {
        sessionStorage.removeItem('requirePasswordChange');
        setMessage({open: true, text: 'Contraseña cambiada correctamente'});
        setTimeout(() => history.push('/'), 1500);
      } else {
        const err = await r.text();
        setMessage({open: true, text: err || 'Error al cambiar la contraseña'});
      }
    } catch (e) {
      setMessage({open: true, text: 'Error de red'});
    }
    setLoading(false);
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          Cambiar contraseña
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="currentPassword"
            label="Contraseña actual"
            type={showCurrentPassword ? 'text' : 'password'}
            autoComplete="current-password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label={
                      showCurrentPassword
                        ? 'Ocultar contraseña'
                        : 'Mostrar contraseña'
                    }
                    onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                    onMouseDown={handleMouseDownPassword}
                    edge="end">
                    {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="newPassword"
            label="Nueva contraseña"
            type={showNewPassword ? 'text' : 'password'}
            autoComplete="new-password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label={
                      showNewPassword
                        ? 'Ocultar contraseña'
                        : 'Mostrar contraseña'
                    }
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    onMouseDown={handleMouseDownPassword}
                    edge="end">
                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="confirm"
            label="Confirmar nueva contraseña"
            type={showConfirmPassword ? 'text' : 'password'}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label={
                      showConfirmPassword
                        ? 'Ocultar contraseña'
                        : 'Mostrar contraseña'
                    }
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    onMouseDown={handleMouseDownPassword}
                    edge="end">
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={loading}>
            Cambiar contraseña
          </Button>
        </form>
        <Snackbar
          open={message.open}
          autoHideDuration={4000}
          onClose={() => setMessage({...message, open: false})}
          message={message.text}
        />
      </div>
    </Container>
  );
}
